var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "crm-card halfWidth"
  }, [_c('div', {
    staticClass: "crm-card-heading"
  }, [_c('div', [_vm._v(" Deals by stage "), _c('b-icon', {
    staticClass: "cursor_pointer infoKbIcon sm-mar-left",
    attrs: {
      "icon": "info-circle-fill"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-dropdown', {
    staticClass: "crm-dd-container",
    attrs: {
      "id": "sound-setting-micro-devices",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('span', {
          staticClass: "d-flex align-items-center p-0"
        }, [_c('span', [_vm._v(_vm._s(_vm._f("get_property")(_vm.selectedPipeline, 'name')))]), _c('b-icon-chevron-down', {
          attrs: {
            "scale": "1.1"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, _vm._l(_vm.GET_CRM_PIPELINES, function (pipeline) {
    return _c('b-dropdown-item', {
      key: pipeline.id,
      on: {
        "click": function ($event) {
          _vm.filters.deals_by_stage.pipeline_id = pipeline.id;
          _vm.fetchDealsByStage();
        }
      }
    }, [_vm.filters.deals_by_stage.pipeline_id == pipeline.id ? _c('vb-svg', {
      attrs: {
        "name": "dialer-tick",
        "width": "10.5",
        "height": "7.584",
        "viewBox": "0 0 10.5 7.584",
        "stroke-width": "0",
        "stroke": "#005DFF",
        "fill": "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(pipeline.name))])], 1);
  }), 1), _c('b-dropdown', {
    staticClass: "crm-dd-container",
    attrs: {
      "id": "sound-setting-micro-devices",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('span', {
          staticClass: "d-flex align-items-center p-0"
        }, [_c('span', [_vm._v(_vm._s(_vm._f("get_property")(_vm.selectedRange, 'label')))]), _c('b-icon-chevron-down', {
          attrs: {
            "scale": "1.1"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, _vm._l(_vm.ranges, function (range) {
    return _c('b-dropdown-item', {
      key: range.value,
      on: {
        "click": function ($event) {
          _vm.filters.deals_by_stage.range = range.value;
          _vm.fetchDealsByStage();
        }
      }
    }, [_vm.filters.deals_by_stage.range == range.value ? _c('vb-svg', {
      attrs: {
        "name": "dialer-tick",
        "width": "10.5",
        "height": "7.584",
        "viewBox": "0 0 10.5 7.584",
        "stroke-width": "0",
        "stroke": "#005DFF",
        "fill": "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(range.label))])], 1);
  }), 1)], 1)]), _c('div', {
    staticClass: "crm-graph-container",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('canvas', {
    ref: "deals_by_stage_chart"
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }